import type { ActiveContractCurrentPeriod } from '../types';

export function franquiaEsgotada(periodo: ActiveContractCurrentPeriod | null | undefined): boolean {
  if (!periodo || periodo.totalBalance === null) return false;
  return periodo.atLimit || periodo.usedBalance >= periodo.totalBalance;
}

export function excedenteDaFranquia(
  periodo: ActiveContractCurrentPeriod | null | undefined,
): number {
  if (!periodo || periodo.totalBalance === null) return 0;
  return Math.max(0, periodo.usedBalance - periodo.totalBalance);
}

export function franquiaDeMensagemEsgotada(
  periodo: ActiveContractCurrentPeriod | null | undefined,
): boolean {
  if (!periodo || periodo.messageBalance === null) return false;
  return periodo.messageAtLimit || periodo.messageUsed >= periodo.messageBalance;
}
